'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = processFilters;

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _selectors = require('../Builder/selectors');

var _FilterCollection = require('./FilterCollection');

var _filters = require('../Homes/filters');

var _filters2 = require('../Lots/filters');

var _filters3 = require('../Plans/filters');

var _filters4 = require('../Communities/filters');

var _filters5 = require('../Blogposts/filters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
  homes: {
    getDependencies: _filters.getHomeFilterDependencies
  },
  lots: {
    getDependencies: _filters2.getLotFilterDependencies
  },
  plans: {
    getDependencies: _filters3.getPlanFilterDependencies
  },
  communities: {
    getDependencies: _filters4.getCommunityFilterDependencies
  },
  blogposts: {
    getDependencies: _filters5.getBlogpostFilterDependencies
  }
};

function processFilters(state) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var items = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var filters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var builderId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _bdcoreUtilities.ConfigStore.getConfig('builder_id');

  var activeFilters = {};
  var getDependencies = function getDependencies() {};

  if (_fp2.default.has((type || '').toLowerCase(), types)) {
    activeFilters = (0, _FilterCollection.getFilters)((type || '').toLowerCase());
    getDependencies = _fp2.default.get((type || '').toLowerCase() + '.getDependencies', types);
  } else {
    throw Error('ERROR:: FILTER:: No filters exist for type ' + type);
  }

  var data = {
    communities: _fp2.default.get('cloudData.communities.' + builderId + '.data')(state),
    areas: (0, _selectors.getAreas)(state),
    plans: _fp2.default.get('cloudData.plans.' + builderId + '.data')(state),
    homes: _fp2.default.get('cloudData.homes.' + builderId + '.data')(state),
    lots: _fp2.default.get('cloudData.lots.' + builderId + '.data')(state),
    widgets: _fp2.default.get('cloudData.settings.' + builderId + '.data.widgets')(state)
  };

  var filterKeys = (0, _keys2.default)(filters).filter(function (key) {
    return _fp2.default.has(key + '.filter', activeFilters);
  });

  return items.filter(function (item) {
    if (!item) {
      return true;
    }

    return _fp2.default.every(function (key) {
      var result = true;

      if (_fp2.default.has(key + '.filter', activeFilters) && filters[key].length) {
        try {
          var filterDependencies = _fp2.default.getOr([], key + '.dependencies', activeFilters);
          var dependencies = getDependencies({
            state: state,
            type: type,
            item: item,
            dependencies: filterDependencies,
            data: data
          });

          if (filterDependencies.find(function (dep) {
            return dep.includes('widget:');
          })) {
            filterDependencies.filter(function (dep) {
              return dep.includes('widget:');
            }).forEach(function (dep) {
              var _dep$split = dep.split(':'),
                  _dep$split2 = (0, _slicedToArray3.default)(_dep$split, 2),
                  widgetKey = _dep$split2[1];

              var widget = (data.widgets || []).find(function (w) {
                return _fp2.default.get('meta.key', w) === widgetKey;
              });

              if (widget) {
                dependencies[widgetKey] = widget;
              }
            });
          }
          result = _fp2.default.get(key + '.filter', activeFilters)(item, (0, _extends3.default)({}, dependencies, { values: filters[key] }));
        } catch (e) {
          result = false;
        }
      }

      return result;
    })(filterKeys);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/processFilters.js
// module id = 939
// module chunks = 0